import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import useSeo from '@/hooks/useSeo';

export default function NotFound() {
  useSeo({
    title: '页面不存在 - 看料社',
    description: '你访问的页面可能已被调整或移除，欢迎返回看料社首页，继续浏览在线看料专题合集。',
    keywords: '看料社,在线看料资源库,页面不存在',
    type: 'website',
  });

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <main className="flex-1 pt-16 md:pt-20 flex items-center">
        <div className="w-full max-w-content mx-auto px-4 md:px-6 py-20 text-center">
          <p className="font-heading text-6xl md:text-8xl font-bold text-background-300">404</p>
          <h1 className="mt-5 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            这页料，暂时找不到了
          </h1>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            页面可能已经调整或改名。你可以回到首页，或者直接去资源库按分类浏览全部专题合集。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/library"
              className="px-6 py-3 rounded-md border border-background-300 text-foreground-800 text-sm hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
            >
              浏览资源库
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}